import React, { useState, useEffect } from "react";
import { BryntumScheduler } from "@bryntum/scheduler-react";
import { schedulerConfig } from "../calendar_config/AppConfig";
import { API_URLS } from "../../api/apiConfig";
import { getWithAuth } from "../../api/api";
import { usePlanification } from "../../planification/planificationContext";
import ModalBookingUpdate from "./modalBookingUpdate";

const CalendarComponent = ({ startDate, endDate }) => {
  const [resources, setResources] = useState([]);
  const [events, setEvents] = useState([]);
  const [isLoading, setIsLoading] = useState(true); // Estado para controlar la carga
  const [updatedSchedulerConfig, setUpdatedSchedulerConfig] = useState({
    ...schedulerConfig,
  }); // Estado para actualizar la configuración del scheduler
  const planificationContext = usePlanification();

  useEffect(() => {
    fetchData(startDate, endDate);
  }, [startDate, endDate]);

  const fetchData = async (start, end) => {
    try {
      const formattedToday = start.toISOString().split("T")[0];
      const formattedNextWeek = end.toISOString().split("T")[0];
      const response = await getWithAuth(
        API_URLS.GET_BOOKINGS_CALENDAR(formattedToday, formattedNextWeek)
      );
      if (response.success) {
        setResources(response.resources.rows);
        setEvents(response.events.rows);
        setIsLoading(false);
      } else {
        console.error("Failed to fetch data");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  // Define el callback para el evento click en un evento del scheduler
  const handleEventClick = ({ event, eventRecord }) => {
    const { deleted, locked, type } = eventRecord.data || {};

    if (deleted /* || locked */) {
      // Evita cualquier acción y burbujeo
      if (event?.preventDefault) event.preventDefault();
      if (event?.stopPropagation) event.stopPropagation();
      return false; // Bryntum suele respetar false para cancelar
    }

    if (type === "booking") {
      planificationContext.openUpdateBookingModal(eventRecord.data.bookingId);
    }
    if (type === "cleaning") {
      planificationContext.openUpdateCleaningModal(eventRecord.data.id);
    }
  };

  const handleTimeSlotClick = ({ resourceRecord, date }) => {
    console.log(date);
    planificationContext.openNewCleaningModalFromCalendar(
      date,
      resourceRecord.data.name,
      resourceRecord.data.id
    );
  };

  useEffect(() => {
    // Actualizar la configuración del scheduler con las nuevas fechas y el listener
    const config = {
      ...schedulerConfig,
      startDate: startDate,
      endDate: endDate,
      zoomOnMouseWheel: false,
      eventDragCreate: false,
      eventResize: false,
      zoomOnTimeAxisDoubleClick: false,
      listeners: {
        eventClick: handleEventClick,
        scheduleClick: handleTimeSlotClick,
      },
      eventRenderer: ({ eventRecord }) => {
        const isLocked = eventRecord.data.locked;
        const isDeleted = eventRecord.data.deleted;

        // Contenido principal del evento
        const content = `
        ${
          isLocked
            ? '<i class="fa fa-lock" style="margin-right:5px; color:gray;"></i>'
            : ""
        }
        ${
          isDeleted
            ? '<i class="fa fa-trash" style="margin-right:5px; color:red;"></i>'
            : ""
        }
        ${eventRecord.name}
    `;

        // Si está eliminado, aplicamos estilos para desactivar visualmente
        const deletedStyle = isDeleted
          ? "opacity: 0.5; box-shadow: 0 0 5px rgba(0,0,0,0.3); border-radius: 4px;"
          : "";

        return {
          html: `<div style="${deletedStyle} padding: 2px 4px;">${content}</div>`,
        };
      },
    };
    setUpdatedSchedulerConfig(config);
  }, [startDate, endDate]);

  return (
    <>
      {isLoading ? (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ height: "10vh" }}
        >
          <div
            className="spinner-grow text-color-amarillo-livensa"
            style={{ width: "5rem", height: "5em" }}
            role="status"
          ></div>
        </div>
      ) : (
        <BryntumScheduler
          {...updatedSchedulerConfig}
          resources={resources}
          events={events}
        />
      )}
    </>
  );
};

export default CalendarComponent;
